import KnackApiWrapper from '@knack/api-wrapper';

const knackApiWrapperSettings = {
  api_uri: `${import.meta.env.PUBLIC_API_URL}/v1`,
  builderVersion: 'next'
};

export const ApiWrapper = new KnackApiWrapper(knackApiWrapperSettings);
